// extracted by mini-css-extract-plugin
module.exports = {"createLink":"User_createLink__1ETxe","link":"User_link__1zrzb"};